import React from 'react'
import { ProjectRow } from 'modules/shares/components/ProjectRow'
import { ParentPermissionsAccessSelect } from 'modules/shares/components/AccessLevelSelect'
import { ProjectFragment, PublicWorkspaceFragment } from '@sketch/gql-types'
import { ShareForSettingsModal } from '../types'
import { useUpdateShareParentPermissions } from '../ParentPermissions/useUpdateShareParentPermissions'
import { Portal } from 'react-portal'
import { capitalize } from '@sketch/utils'
import { ConfirmationDialog } from '@sketch/components'

export interface ProjectRowProps {
  share: Pick<
    ShareForSettingsModal,
    | 'identifier'
    | 'userCanUpdateSettings'
    | 'parentAccessLevel'
    | 'type'
    | 'allowedParentAccessLevels'
    | 'isDraft'
    | 'workspace'
    | 'name'
  >
  project: ProjectFragment
  workspace: PublicWorkspaceFragment
  actions: React.ReactNode
}

const ProjectPermissions = ({ share, project, workspace }: ProjectRowProps) => {
  const {
    getUpdateShareParentPermissionsConfirmDialogProps,
    getUpdateShareParentPermissionsDropdownProps,
    updateShareParentPermissionsConfirmDialogOpen,
    shareParentAccessLevel,
  } = useUpdateShareParentPermissions({ share })
  const dropdownProps = getUpdateShareParentPermissionsDropdownProps()

  return (
    <>
      <ProjectRow
        project={project}
        workspace={workspace}
        actions={
          <ParentPermissionsAccessSelect
            {...dropdownProps}
            level={
              (dropdownProps.level as string) === 'INSPECT'
                ? 'VIEW'
                : dropdownProps.level
            }
          />
        }
      />

      {updateShareParentPermissionsConfirmDialogOpen && (
        <Portal>
          <ConfirmationDialog
            {...getUpdateShareParentPermissionsConfirmDialogProps()}
            title={`Change Workspace Access to ${capitalize(
              shareParentAccessLevel
            )}?`}
            confirmButton={{ text: 'Change Access', variant: 'negative' }}
          >
            You’ll no longer be able to edit “{share.name}”. To get edit access
            again, ask an Admin or somebody with edit access to add you.
          </ConfirmationDialog>
        </Portal>
      )}
    </>
  )
}

export { ProjectPermissions }
